"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#014965",
    d: "M5.5,14a1.5,1.5,0,0,1,0-3H14V1.5a.5.5,0,0,0-.5-.5H.5a.5.5,0,0,0-.5.5v21a.5.5,0,0,0,.5.5h13a.5.5,0,0,0,.5-.5V14Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#014965",
    d: "M5.5,13H22.29l-4.14,4.15a.49.49,0,0,0,.7.7l5-5a.48.48,0,0,0,0-.7l-5-5a.49.49,0,0,0-.7.7L22.29,12H5.5a.5.5,0,0,0,0,1Z"
  }));
};

exports["default"] = _default;